import { Palette } from '@mui/material';

export const menuItemRoot = (palette: Palette) => ({
	'&:hover': {
		backgroundColor: palette.background.selected,
		color: palette.mode === 'dark'
			? palette.skodaColors['neutrals-white']
			: palette.skodaColors['neutrals-chrome900']
	},
	'&:focus': {
		backgroundColor: 'unset',
		'&:hover': {
			backgroundColor: palette.background.selected
		}
	},
	'&.Mui-selected': {
		backgroundColor: palette.background.selected,
		color: palette.text.primary,
		fontWeight: undefined,
		'&:hover': {
			backgroundColor: palette.background.selected
		},
		'&:focus': {
			backgroundColor: palette.background.selected,
			'&:hover': {
				backgroundColor: palette.background.selected
			}
		}
	}
});

export const menuItemRootDark = (palette: Palette) => ({
	color: 'rgba(256,256,256,0.5)',
	'&:hover': {
		backgroundColor: 'unset',
		color: palette.skodaColors['neutrals-white']
	},
	'&:focus': {
		backgroundColor: 'unset'
	},
	'&.Mui-selected': {
		backgroundColor: 'unset',
		color: palette.skodaColors['neutrals-white'],
		fontWeight: 'bold',
		'&:hover': {
			backgroundColor: 'unset'
		}
	}
});
